// extracted by mini-css-extract-plugin
module.exports = {"footer":"EditUserAvailabilityStepReasonToClose_footer__1JywS"};